import * as React from "react"

const SCROLL_THRESHOLD = 20

export const useScrollVisibility = (threshold = SCROLL_THRESHOLD) => {
  const [isHidden, setIsHidden] = React.useState(true)
  const [isScrolled, setIsScrolled] = React.useState(false)

  const lastScrollTopPosition = React.useRef(0)
  const headerRef = React.useRef<HTMLElement>(null)
  const navbarHeight = React.useRef(headerRef.current?.offsetHeight || 0)

  const handleScroll = React.useCallback(() => {
    // This is to prevent the scroll lock from generating 1px of movement in Safari
    // and to avoid unwanted behavior in the header that appears and disappears depending on the scroll
    // The data-scroll-locked attribute is set in the body when the Vaul Drawer library is opened
    const isScrollLocked = document.body.getAttribute("data-scroll-locked") === "1"
    if (isScrollLocked) return
    if (!window.requestAnimationFrame) return

    window.requestAnimationFrame(() => {
      const currentScrollTop = window.scrollY
      const lastScrollTop = lastScrollTopPosition.current

      if (Math.abs(lastScrollTop - currentScrollTop) <= threshold) return

      setIsHidden(currentScrollTop > lastScrollTop && currentScrollTop > navbarHeight.current)
      setIsScrolled(currentScrollTop > threshold)
      lastScrollTopPosition.current = currentScrollTop
    })
  }, [threshold])

  React.useEffect(() => {
    navbarHeight.current = headerRef.current?.offsetHeight || 0

    const controller = new AbortController()
    window.addEventListener("scroll", handleScroll, {
      signal: controller.signal,
      passive: true
    })
    return () => controller.abort()
  }, [])

  return { isHidden, isScrolled, headerRef }
}
